import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const valueBreakdown = [{
  item: 'Método Jabones Artesanales',
  value: 97
}, {
  item: 'Desodorantes Naturales',
  value: 47
}, {
  item: 'Cosmética Sólida',
  value: 57
}, {
  item: 'Maquillaje Natural',
  value: 67
}, {
  item: 'Cuidado de la Piel',
  value: 77
}, {
  item: 'Velas Artesanales',
  value: 47
}, {
  item: 'Certificado',
  value: 29
}, {
  item: 'Membresía VIP',
  value: 97
}];
export function Pricing() {
  const totalValue = valueBreakdown.reduce((sum, item) => sum + item.value, 0);
  return <section className="w-full bg-[var(--bg-darker)] py-20 px-4" data-id="element-101">
      <div className="max-w-4xl mx-auto" data-id="element-102">
        <motion.h2 className="text-4xl md:text-5xl font-black text-[var(--text-light)] mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-103">
          Hagamos Las Cuentas
        </motion.h2>

        <motion.div className="bg-[var(--bg-card)] rounded-2xl p-8 md:p-12 mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-104">
          <div className="space-y-4 mb-8" data-id="element-105">
            {valueBreakdown.map((item, index) => <motion.div key={index} className="flex justify-between items-center pb-4 border-b border-gray-300" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + index * 0.05,
            duration: 0.4
          }} data-id="element-106">
                <span className="text-lg md:text-xl text-[var(--text-light)]" data-id="element-107">
                  {item.item}
                </span>
                <span className="text-lg md:text-xl font-bold text-[var(--accent-orange-light)]" data-id="element-108">
                  ${item.value} USD
                </span>
              </motion.div>)}
          </div>

          <motion.div className="pt-6 border-t-2 border-[var(--accent-orange)]" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.6
        }} data-id="element-109">
            <div className="flex justify-between items-center mb-8" data-id="element-110">
              <span className="text-2xl md:text-3xl font-bold text-[var(--text-light)]" data-id="element-111">
                Valor Total:
              </span>
              <span className="text-3xl md:text-4xl font-black text-[var(--accent-orange)]" data-id="element-112">
                ${totalValue} USD
              </span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 1,
        duration: 0.6
      }} data-id="element-113">
          <p className="text-2xl md:text-3xl text-[var(--text-light)] mb-6" data-id="element-114">
            Y sin embargo…
          </p>
          <p className="text-xl md:text-2xl text-[var(--text-gray)] mb-8" data-id="element-115">
            No vas a pagar ${totalValue} USD. Ni $297 USD. Ni siquiera $97 USD.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[var(--text-light)] mb-4" data-id="element-116">
            Hoy puedes acceder por solo:
          </p>
        </motion.div>

        <motion.div className="bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] rounded-2xl p-12 text-center mb-12" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1.2,
        duration: 0.6
      }} data-id="element-117">
          <div className="mb-6" data-id="element-118">
            <span className="text-3xl md:text-4xl text-white/80 line-through" data-id="element-119">
              $97 USD
            </span>
          </div>
          <div className="text-7xl md:text-8xl lg:text-9xl font-black text-white mb-4" data-id="element-120">
            $19
          </div>
          <p className="text-2xl md:text-3xl text-white font-bold" data-id="element-121">USD</p>
        </motion.div>

        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 1.4,
        duration: 0.6
      }} data-id="element-122">
          <p className="text-lg md:text-xl text-[var(--text-gray)] mb-8" data-id="element-123">
            Menos que el costo de una tarde desperdiciando materiales por no
            tener una fórmula correcta.
          </p>
          <CTAButton size="large" data-id="element-124">SÍ, QUIERO ACCEDER POR $19</CTAButton>
        </motion.div>
      </div>
    </section>;
}